import { CONTACT_URL } from "../utils/constants/ApiConstants";
import { httpClient } from "./http/httpClient";

export type ContactType = "BUG_REPORT" | "FEATURE_REQUEST" | "COMPLAINT" | "QUESTION" | "OTHER";

export interface ContactRequest {
  type: ContactType;
  subject: string;
  message: string;
}

export interface ContactResponse {
  message: string;
}

export async function sendContact(contact: ContactRequest): Promise<ContactResponse> {
  const { data } = await httpClient.post<ContactResponse, ContactRequest>(
    CONTACT_URL,
    contact,
    { authenticated: true }
  );
  return data;
}

